<template>
	<div class="flex flex-col">
		<div v-if="!hide" class="bg-color-4 text-color-text font-semibold text-3xl rounded-lg flex items-center">
				<div class="flex flex-col items-center grow px-4 py-1">
					<div>{{ $t('eny.user_id') }}</div>
					<div>{{ user.kc_user_id }}</div>
				</div>
				<div class="flex flex-col items-center grow px-4 py-1">
					<div>{{ $t('eny.request') }}</div>
					<div>{{ request.id }}</div>
				</div>
				<div class="flex flex-col items-center grow px-4 py-1">
					<div>{{ $t('eny.dob') }}</div>
					<div>{{ this.timeZoneOffsetOnInit(request.dob, $t('eny.moment_date_format')) }}</div>
				</div>
				<div class="flex flex-col items-center grow px-4 py-1">
					<div>{{ user.given_name }}</div>
					<div>{{ user.family_name }}</div>
				</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import useUtils from '../../hooks/useUtils';

export default {
	name: "InfoHeader",
	setup() {
		const { timeZoneOffsetOnInit } = useUtils();
		return {
			timeZoneOffsetOnInit
		}
	},
	computed: {
		...mapGetters('customer', ['request', 'user', 'loading']),
		hide: function() {//hide header, when loading new customer data
			return this.loading && this.$route.params.uid && this.request.user_id!=this.$route.params.uid
		}
	}
}
</script>
